import PropTypes from 'prop-types';

export type Product = {
  productName: string;
  productKey: string;
};

export type Offering = {
  daysRemaining?: number | null;
  offeringName: string;
  type: string;
  endDate?: string | null;
  startDate: string;
  sheetCount?: number | null;
  products: Product[];
  alternativeSubscription?: AlternativeOffering | undefined | null;
  status: string;
};

export type AlternativeOffering = {
  daysRemaining?: number | null;
  offeringName: string;
  type: string;
};

export const productsPropType = PropTypes.shape({
  productName: PropTypes.string.isRequired,
  productKey: PropTypes.string.isRequired,
});

export const alternativeOfferingPropType = PropTypes.shape({
  daysRemaining: PropTypes.number,
  offeringName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export const offeringPropType = PropTypes.shape({
  daysRemaining: PropTypes.number,
  offeringName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  endDate: PropTypes.string,
  sheetCount: PropTypes.number,
  startDate: PropTypes.string.isRequired,
  products: PropTypes.arrayOf(productsPropType.isRequired).isRequired,
  alternativeSubscription: alternativeOfferingPropType,
  status: PropTypes.string.isRequired,
});
